
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.75 23.998a.755.755 0 01-.26-.047l-.022-.008a.732.732 0 01-.249-.165l-2.999-3c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53a.744.744 0 011.06 0L3 21.438V2.559l-1.72 1.72a.744.744 0 01-1.06-.001c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53L3.219.219A.74.74 0 013.49.045a.733.733 0 01.521.001l.021.007a.74.74 0 01.249.166L7.28 3.218c.142.141.22.33.22.53s-.078.389-.22.53c-.141.142-.33.22-.53.22s-.389-.078-.53-.22L4.5 2.559v18.879l1.72-1.72a.744.744 0 011.06 0 .744.744 0 010 1.06l-3 3a.763.763 0 01-.246.164l-.027.01a.746.746 0 01-.257.046zM15.75 1.498a.75.75 0 010-1.5h7.5a.75.75 0 010 1.5h-7.5zM11.25 5.998a.75.75 0 010-1.5h12a.75.75 0 010 1.5h-12zM11.25 10.498a.75.75 0 010-1.5h12a.75.75 0 010 1.5h-12zM15.75 14.998a.75.75 0 010-1.5h7.5a.75.75 0 010 1.5h-7.5zM11.25 19.498a.75.75 0 010-1.5h12a.75.75 0 010 1.5h-12zM11.25 23.998a.75.75 0 010-1.5h12a.75.75 0 010 1.5h-12z"}})])
          )
        }
      }
    